export default __webpack_public_path__ + "static/media/think-outside-the-box.8bd6e7ac.svg";